import { createContext, useContext, useEffect, useState, type ReactNode } from "react";
import { api, type PublicBrand } from "@/api/client";
import { applyBrandTheme } from "@/lib/theme";

export { applyBrandTheme };

const Ctx = createContext<PublicBrand | null>(null);

/** Public side: the brand is the host's; its colours go on the document (see lib/theme.ts). */
export function BrandProvider({ children }: { children: ReactNode }) {
  const [brand, setBrand] = useState<PublicBrand | null>(null);
  useEffect(() => {
    const override = new URLSearchParams(location.search).get("brand");
    api<PublicBrand>(`/public/brand${override ? `?brand=${override}` : ""}`)
      .then((b) => {
        setBrand(b);
        applyBrandTheme(b.slug, b.theme);
        document.title = b.name.el ?? b.name.en ?? "STUDIO";
      })
      .catch(() => setBrand(null));
  }, []);
  return <Ctx.Provider value={brand}>{children}</Ctx.Provider>;
}

export const useBrand = () => useContext(Ctx);
